import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { ListSubChannelsRequestFilterSensitiveLog, ListSubChannelsResponseFilterSensitiveLog, } from "../models/models_0";
import { de_ListSubChannelsCommand, se_ListSubChannelsCommand } from "../protocols/Aws_restJson1";
export { $Command };
export class ListSubChannelsCommand extends $Command
    .classBuilder()
    .ep({
    ...commonParams,
})
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("ChimeMessagingService", "ListSubChannels", {})
    .n("ChimeSDKMessagingClient", "ListSubChannelsCommand")
    .f(ListSubChannelsRequestFilterSensitiveLog, ListSubChannelsResponseFilterSensitiveLog)
    .ser(se_ListSubChannelsCommand)
    .de(de_ListSubChannelsCommand)
    .build() {
}
